
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#400F3F","rx":"8.258"}}),_c('path',{attrs:{"fill":"#FF4702","d":"M31.453 40.547l6.427-6.427a2.67 2.67 0 00.787-1.893V20A2.667 2.667 0 0036 17.333H21.333A2.667 2.667 0 0018.667 20v18.667a2.667 2.667 0 002.666 2.666h8.227c.71 0 1.392-.282 1.893-.786zm-2.12-7.214c0-.736.597-1.333 1.334-1.333h5.573l-6.907 6.907v-5.574zm12-10.666v18.666A2.667 2.667 0 0138.667 44H24a2.667 2.667 0 002.667 2.667h12A5.334 5.334 0 0044 41.333v-16a2.667 2.667 0 00-2.667-2.666z"}})])])
          )
        }
      }
    